/**
 * Created by abhishek.panda on 13/09/17.
 */

import styled from 'styled-components';
import { colors } from '../../colorCodes';

export const Ul = styled.ul`
    height: ${props => props.height || '50px'};
    width: ${props => props.width || 'auto'};
    overflow: scroll;
    padding: 0;
    margin: 0;
`;

export const Pointer = styled.div`
    border-top: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid ${colors.whiteText};
    border-left: 7px solid ${colors.whiteText};
    position: absolute;
    top: 20px;
    left: -7px;
    box-shadow: rgba(208, 208, 208, 0.5) -2px 2px 1px -1px;
    transform: rotate(45deg);
    z-index: 1;
`;

export const Li = styled.li`
    font-family: 'Arial';
    color: rgb(63, 63, 63);
    font-size: 14px;
    border-bottom: 1px solid ${colors.treeMenuItemBorderColor};
    padding: 12px 16px;
    word-wrap: break-word;
    cursor: pointer;
    list-style-type: none;
`;
